<div class="auth-page">
  <div class="auth-panel">
    <div class="auth-brand">
      <span class="mark">R</span>
      <h1>Rentwize</h1>
      <p>Admin sign in</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form">
      <label>
        <span>Email</span>
        <input type="email" formControlName="email" autocomplete="username" />
      </label>

      <label>
        <span>Password</span>
        <input type="password" formControlName="password" autocomplete="current-password" />
      </label>

      @if (error()) {
        <div class="alert alert-error">{{ error() }}</div>
      }

      <button class="btn btn-primary btn-block" type="submit" [disabled]="loading()">
        {{ loading() ? 'Signing in…' : 'Continue' }}
      </button>
    </form>
  </div>
</div>
